module.exports = __webpack_public_path__ + "assets/c1df97690eb115996699f6f4a24f4621.mp3";